import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { ValidateFilesOptions } from "../types";
import { validateFiles as validateFilesUtil } from "../utils/validation";

export const useFileStorageValidator = () => {
  const { t } = useTranslation();

  const validateFiles = useCallback(
    async (
      files: File[],
      options: ValidateFilesOptions = {},
    ): Promise<string | null> => {
      const error = await validateFilesUtil(files, options);
      return error
        ? t(`fileAttachments.${error.type}`, error.metadata || {})
        : null;
    },
    [t],
  );

  return { validateFiles };
};
